import { render, staticRenderFns } from "./BelezaDasTrevas.vue?vue&type=template&id=4a374789&"
import script from "./BelezaDasTrevas.vue?vue&type=script&lang=js&"
export * from "./BelezaDasTrevas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports